'use client';

import useCartStore from '@/store/cartStore';
import useCommonStore from '@/store/commonStore';
import useWishListStore from '@/store/wishListStore';
import { useEffect } from 'react';

export default function AuthProvider({ children }: { children: React.ReactNode }) {
    const { checkAuth, checkUser, logout, } = useCommonStore()
    const { cart, updateUserCart, cartDetails, setCart } = useCartStore()
    const { wishList, updateUserWishList } = useWishListStore()

    useEffect(() => {
        checkTokenValidity();
    }, [checkAuth]);
    const checkTokenValidity = async () => {
        const isAuth = checkAuth();
        if (isAuth) {
            const verifyMe = await checkUser();
            if (verifyMe.status) {
                   await updateUserCart({ items: cart || [] });
                   await updateUserWishList({ items: wishList || [] });
            } else {
                await logout();
            }
        }
    }
    return children;
}